import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import React, {useState} from 'react'
import ActionButtonConfig from 'Event/template/Townhall/Dashboard/ActionNav/ActionButton/ActionButtonConfig'

export default function NewActionButton(props: {className?: string}) {
  const [button, setButton] = useState<NavButtonWithSize | null>(null)

  const clearButton = () => setButton(null)

  const addButton = () => {
    const button: NavButtonWithSize = {
      text: 'Button',
      link: '',
      size: 12,
      rules: [],
      isAreaButton: false,
      isImageUpload: false,
      isFormButton: false,
      isCertificateButton: false,
      areaId: null,
      formId: null,
      actionId: null,
      certificateId: null,
      isVisible: true,
      infusionsoftTag: null,
      mailchimpTag: null,
      zapierTag: null,
      highLevelTag: null,
      webhook: null,
      backgroundColor: '#000000',
      hoverBackgroundColor: '#000000',
      textColor: '#FFFFFF',
      hoverTextColor: '#FFFFFF',
      disableHover: true,
      hubspotTag: null,
      activeCampaignTag: null,
      ontraportTag: null,
      convertKitTag: null,
    }

    setButton(button)
  }
  return (
    <>
      <NewButtonConfig button={button} onClose={clearButton} />
      <Grid item xs={12} className={props.className}>
        <Button
          fullWidth
          size="large"
          variant="outlined"
          color="primary"
          aria-label="add action nav button"
          onClick={addButton}
        >
          New Button
        </Button>
      </Grid>
    </>
  )
}

function NewButtonConfig(props: {
  button: NavButtonWithSize | null
  onClose: () => void
}) {
  if (!props.button) {
    return null
  }

  return (
    <ActionButtonConfig showing onClose={props.onClose} button={props.button} />
  )
}
